/* src/app/components/order-content/order-content.component.scss */
ion-content {
  padding: 0 10px;
}
.toolbar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px 20px;
  background: white;
  align-items: center;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.2509803922);
}
.toolbar p {
  margin: 0px;
  color: var(--ion-color-secondary) !important;
}
.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
}
.promo-info .name {
  width: 180px;
}
.promo-info {
  display: none;
}
.min-order {
  margin: 10px 10px 0;
}
.add-more {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 34px;
  min-width: fit-content;
  padding-inline: 7px;
  cursor: pointer;
  border-radius: 22px;
  background-color: var(--ion-color-primary);
  padding: 10px;
}
.add-more .add-text {
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0px;
  text-align: left;
  color: white;
}
.add-more .add-button {
  margin-right: 12px;
}
.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.wrapper-block {
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper-block .height-block {
    height: 100% !important;
  }
}
.wrapper {
  max-height: 100%;
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper {
    padding-bottom: 0px;
    background: #0d1117;
  }
}
@media (max-width: 992px) {
  .wrapper .border-line {
    background: #0d1117;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
  }
}
.wrapper .border-line {
  border-radius: 35px;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
}
@media (min-width: 991px) {
  .wrapper .border-line {
    height: calc(100% - 10px);
  }
}
.wrapper .border-line {
  flex-direction: column;
  display: flex;
  background-size: cover;
  position: relative;
}
.wrapper .border-line .cross-selector {
  position: absolute;
  top: 20px;
  left: 20px;
  margin: 0px;
  width: 20px;
  height: 20px;
  padding: 0px;
  z-index: 99;
  cursor: pointer;
  filter: brightness(0) invert(1);
}
@media (max-width: 992px) {
  .wrapper .border-line {
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.order-list {
  width: 100%;
}
.promo-code {
  width: 100%;
}
.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}
.ordered-articles {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #0d1117;
  flex-shrink: 0;
}
@media (max-width: 992px) {
  .ordered-articles {
    min-height: auto;
  }
}
.ordered-articles-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title {
  font-size: 25px;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  color: #000;
  margin-bottom: 18px;
}
.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}
.no-articles {
  display: flex;
  padding: 40px 20px;
  justify-content: center;
  align-items: center;
}
.no-articles ion-icon {
  color: white;
  fill: white;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .no-articles ion-icon {
    fill: black;
    color: black;
  }
}
.no-articles ion-icon {
  display: none;
}
@media (min-width: 991px) {
  .no-articles ion-icon.big-screen {
    display: block;
  }
}
@media (max-width: 992px) {
  .no-articles ion-icon.small-screen {
    display: block;
  }
}
.no-articles h3 {
  color: #fff;
  font-size: 16px;
}
.footer-buttons {
  padding: 20px 18px;
  background: #0d1117;
}
.finish-btn {
  padding: 10px 20px;
}
@media (max-width: 992px) {
  .finish-btn {
    display: none;
  }
}
.finish-btn .footer-btn {
  width: 100%;
}
.finish-btn .footer-btn .footer-btn-text {
  font-size: 14px !important;
  color: white;
}
.promo-section {
  border-top: 1px solid #383838;
  border-bottom: 1px solid #383838;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (max-width: 992px) {
  .promo-section {
    padding: 5px 20px;
  }
}
.promo-section.no-border {
  border-top: none;
}
.promo-section ion-icon {
  width: 30px;
  height: 30px;
}
.promo-section h3 {
  margin-left: 10px;
  font-size: 16px;
  text-transform: uppercase;
  color: #fff;
}
@media (max-width: 992px) {
  .promo-section h3 {
    font-size: 14px;
  }
}
.tips {
  padding: 10px 20px 0px;
}
.delete-promo {
  justify-content: space-between;
}
.delete-promo .delete-items-section {
  display: flex;
  align-items: center;
}
.delete-promo .delete-items-section ion-icon {
  margin-left: 15px;
}
.form-section-input .form-section-title {
  padding-top: 15px;
  padding-bottom: 20px;
  border-top: 1px solid var(--color-black);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 992px) {
  .form-section-input .form-section-title {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
.form-section-input .form-section-title .rotate-icon {
  rotate: 0deg;
  transition: rotate 0.5s ease-in-out;
}
.form-section-input .form-section-title .rotate-icon.rotate {
  rotate: 180deg;
}
.form-section-input h3 {
  font-size: 16px;
  text-transform: uppercase;
  color: var(--color-black);
}
.address-selection {
  padding: 13px 20px;
}
.address-selection h3 {
  font-size: 14px;
}
.name_row {
  padding: 10px 10px 13px 15px;
  color: #fff;
  display: flex;
  align-items: center;
  border-top: 1px solid #383838;
}
.name-block b {
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  color: #fff;
}
.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}
.circle ion-icon {
  width: 30px;
  height: 30px;
}
.error_container {
  margin: 0;
  margin-top: 5px;
  margin-bottom: 5px;
}
.added-gift {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 20px;
  border-bottom: 1px solid #383838;
  cursor: pointer;
}
.added-gift .header-gift {
  width: 35px;
  height: 35px;
  min-height: 35px;
  min-width: 35px;
  background: #f48b7f;
  border: 1px solid #383838;
  border-radius: 50%;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}
.added-gift .inner-text-gift {
  margin-left: 5px;
}
.added-gift .inner-text-gift h3 {
  text-transform: uppercase;
  font-size: 12px;
  color: #fff;
}
.added-gift .inner-text-gift p {
  text-transform: uppercase;
  font-size: 12px;
  color: #fff;
}
.added-gift .delete-items-section {
  margin-left: auto;
}
.added-gift ion-icon {
  width: 25px;
  height: 25px;
}
.error-message {
  text-align: center;
  color: var(--ion-color-secondary);
  padding-bottom: 5px;
  font-size: 12px;
}
.promo-block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  padding-block: 13px;
  margin-inline: 18px;
  margin-bottom: 10px;
  border-top: 1px solid rgba(0, 0, 0, 0.3019607843);
  border-bottom: 1px solid rgba(0, 0, 0, 0.3019607843);
}
.promo-block ion-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}
.promo-block .promo-text {
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 8%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.promo-block ion-img {
  width: 50px;
  margin-right: auto;
}
.promo-block .delete-items-section {
  margin-left: auto;
}
.recommendation-section {
  padding: 10px 0 19px;
  background-color: #0d1117;
}
.recommendation-section .recommendation-title {
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 2%;
  text-transform: uppercase;
  color: #fff;
  margin: 0 0 12px 0;
  padding: 0 18px;
}
.recommendation-section .recommendation-slider-container {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.recommendation-section .recommendation-slider-container::-webkit-scrollbar {
  display: none;
}
.recommendation-section .recommendation-slider {
  display: flex;
  gap: 15px;
  padding: 0 18px 10px;
  width: max-content;
}
.recommendation-section .recommendation-card {
  background: #23262C;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
  flex-shrink: 0;
  width: 280px;
}
@media (max-width: 992px) {
  .recommendation-section .recommendation-card {
    width: 260px;
  }
}
.recommendation-section .recommendation-card:hover {
  transform: translateY(-2px);
}
.recommendation-section .recommendation-card .recommendation-image {
  width: 100%;
  height: 180px;
  background: #2a2a2a;
  display: flex;
  align-items: center;
  justify-content: center;
}
.recommendation-section .recommendation-card .recommendation-image ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.recommendation-section .recommendation-card .recommendation-info {
  padding: 15px;
}
.recommendation-section .recommendation-card .recommendation-info .recommendation-name {
  font-size: 16px;
  line-height: 120%;
  text-transform: uppercase;
  color: #fff;
  margin: 0 0 8px 0;
  min-height: 38px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommendation-section .recommendation-card .recommendation-info .recommendation-price {
  font-size: 14px;
  color: #fff;
  margin: 0 0 8px 0;
}
.recommendation-section .recommendation-card .recommendation-info .recommendation-description {
  font-size: 11px;
  line-height: 140%;
  color: #ccc;
  margin: 0 0 12px 0;
  min-height: 32px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommendation-section .recommendation-card .recommendation-info .recommendation-btn {
  --border-color: #004FFF;
  --color: #fff;
  --background: transparent;
  --border-width: 1px;
  --border-radius: 25px;
  height: 35px;
  font-size: 11px;
  width: 100%;
  text-transform: uppercase;
}
.footer-wrapper {
  position: sticky;
  bottom: 0;
  margin-top: auto;
  background: #0d1117;
  z-index: 100;
}
.footer {
  background: #0d1117;
}
.footer-total-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 18px;
  border-top: 1px solid #383838;
}
.footer-total-section .footer-total-text {
  font-size: 18px;
  line-height: 110%;
  color: #fff;
  margin: 0;
}
.footer-total-section .footer-total-price {
  font-size: 18px;
  line-height: 110%;
  color: #fff;
  margin: 0;
}
.footer-total-section .products-count {
  font-weight: AppFont;
  font-size: 18px;
  color: #B3B6B9;
}
.footer-total-section .total-price-container {
  display: flex;
  align-items: center;
  gap: 2px;
}
.quantity {
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-black);
  border-radius: 50%;
  background: var(--color-background-alt);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: var(--color-black);
}
.header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 2rem;
  background: #0d1117;
  position: sticky;
  top: 0;
  z-index: 100;
  border-bottom: 1px solid #383838;
}
.cart-title {
  font-size: 22px;
  text-transform: uppercase;
  color: #fff;
  margin: 0;
}
.back-icon {
  width: 22px;
  height: 22px;
}
.send-order-button {
  height: 60px;
}
.applied-promo-section {
  background: #23262C;
  border-top: 1px solid #383838;
  border-bottom: 1px solid #383838;
  padding: 12px 18px;
}
.applied-promo-section .promo-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.applied-promo-section .promo-info-row .promo-icon {
  font-size: 20px;
  color: #fff;
}
.applied-promo-section .promo-info-row .promo-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.applied-promo-section .promo-info-row .promo-details .promo-code-text {
  font-size: 11px;
  color: #B3B6B9;
  text-transform: uppercase;
}
.applied-promo-section .promo-info-row .promo-details .promo-code-name {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}
.applied-promo-section .promo-info-row .remove-promo-icon {
  font-size: 24px;
  color: #ff4d4d;
  cursor: pointer;
  transition: color 0.2s;
}
.applied-promo-section .promo-info-row .remove-promo-icon:hover {
  color: #ff1a1a;
}
/*# sourceMappingURL=order-content.component.css.map */
